declare var window

const Backbone = require('backbone')

const Ambiente = Backbone.Model.extend({

});

const Ambientes = Backbone.Collection.extend({
    model: Ambiente
})

window.Ambientes = Ambientes

export {Ambientes}